import { AxiosError } from 'axios'

export function getErrorMessage(error: unknown, fallback?: string): string {
  if (error instanceof AxiosError && error.response) {
    const { status, data } = error.response

    // Handle specific HTTP status codes
    if (status === 413) {
      return 'File is too large. Please check the size limit for your plan.'
    }

    if (status === 429) {
      return 'Too many requests. Please wait a moment and try again.'
    }

    // If data is a string and reasonably short, use it directly
    if (typeof data === 'string' && data.length < 200) {
      return data.trim()
    }

    // If data has a message field, use that
    if (data && typeof data === 'object') {
      if (typeof data.message === 'string') {
        return data.message
      }
      if (typeof data.detail === 'string') {
        return data.detail
      }
    }
  }

  return fallback || 'Something went wrong'
}
